import styled from 'styled-components'
import { deviceMax } from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import CloseButtonSvg from '../../images/icons/close-modal.svg'

export const StyledModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.opacity.black80};
`

export const CloseButton = styled(CloseButtonSvg)`
  position: absolute;
  z-index: 55;
  right: ${pxToRem(20)};

  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  box-sizing: border-box;
  cursor: pointer;
  @media ${deviceMax.mobileM} {
    width: ${pxToRem(20)};
    height: ${pxToRem(20)};
    top: ${pxToRem(10)};
    right: ${pxToRem(10)};
  }
`

export const StyledCard = styled.div`
  overflow-x: auto;
  position: relative;
  flex-direction: row;
  display: flex;
  background-color: ${({ theme }) => theme.colors.unique.white};
  width: 100%;
  max-width: ${pxToRem(792)};
  padding: ${pxToRem(20)};
  border-radius: ${pxToRem(5)};
  gap: ${pxToRem(20)};

  ::-webkit-scrollbar {
    width: 4px;
  }

  @media ${deviceMax.tablet} {
    margin: 0 ${pxToRem(10)};
  }
  @media ${deviceMax.mobileM} {
    flex-direction: column;
    overflow: auto;
    align-items: center;
  }
`

export const StyledMedia = styled.div`
  border-radius: ${pxToRem(30)};
  height: ${pxToRem(223)};
  width: ${pxToRem(223)};
  min-width: ${pxToRem(223)};

  img,
  video,
  iframe {
    height: ${pxToRem(223)};
    width: ${pxToRem(223)};
    object-fit: cover;
    border-radius: ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(30)} ${pxToRem(5)};
  }
`

export const StyledBody = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
  max-height: ${pxToRem(200)};
  @media ${deviceMax.mobileM} {
    overflow: initial;
  }
`

export const StyledHeader = styled.div`
  flex-direction: row;
  display: flex;
  padding-right: ${pxToRem(20)};
  justify-content: space-between;
  width: 100%;
`

export const StyledTitle = styled.div`
  margin-bottom: ${pxToRem(10)};
  font-weight: ${({ theme }) => theme.fonts.weight.semibold};
  font-size: ${({ theme }) => theme.fonts.sizes.titleH3};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH3};
`

export const StyledSubtitle = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  margin-bottom: ${pxToRem(10)};
  font-size: ${({ theme }) => theme.fonts.sizes.button};
  line-height: ${({ theme }) => theme.fonts.lineHeight.button};
  color: ${({ theme }) => theme.colors.opacity.black70};
`

export const StyledHorinzontalSlash = styled.div`
  width: ${pxToRem(20)};
  height: ${pxToRem(2)};
  background-color: ${({ theme }) => theme.colors.primary.lime};
  margin-right: ${pxToRem(10)};
`

export const StyledText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  padding-right: ${pxToRem(10)};
  color: ${({ theme }) => theme.colors.opacity.black70};
  overflow: auto;

  ::-webkit-scrollbar {
    width: 4px;
  }
`
